class RejectExpenseModalController {
  constructor($uibModalInstance, toastr, modalContext) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.toastr = toastr;
    this.modalContext = modalContext || {};

    this.isReimbursement = !!this.modalContext.isReimbursement;
    this.reportName = this.modalContext.reportName || 'this expense report';
    this.title = this.isReimbursement ? 'Reject Reimbursement' : 'Reject Expense Report';
    this.confirmLabel = this.isReimbursement ? 'Reject Reimbursement' : 'Reject Report';
    this.detailsPlaceholder = this.isReimbursement
      ? 'e.g. Receipt for lodging is missing, or actual amount does not match the attached invoice.'
      : 'e.g. Please attach estimate basis for the rental car and correct the trip dates.';

    this.reasonOptions = this.isReimbursement
      ? [
        'Missing or incomplete receipts',
        'Actual amount does not match documentation',
        'Payment method is missing or incorrect',
        'Mileage evidence is insufficient',
        'Expense is not reimbursable',
        'Other (explain below)'
      ]
      : [
        'Incomplete or unclear itinerary',
        'Missing estimate basis / supporting documentation',
        'Estimated amounts appear unreasonable',
        'Wrong project or trip purpose selected',
        'Mileage evidence is insufficient',
        'Duplicate or overlapping expenses',
        'Other (explain below)'
      ];

    this.selectedReasons = [];
    this.details = '';
    this.errorMessage = '';
  }

  isReasonSelected(option) {
    return this.selectedReasons.indexOf(option) !== -1;
  }

  toggleReason(option) {
    const index = this.selectedReasons.indexOf(option);
    if (index === -1) {
      this.selectedReasons.push(option);
    } else {
      this.selectedReasons.splice(index, 1);
    }
    this.errorMessage = '';
  }

  requiresDetails() {
    return this.selectedReasons.indexOf('Other (explain below)') !== -1
      || this.selectedReasons.length === 0;
  }

  canSubmit() {
    if (!this.selectedReasons.length) {
      return false;
    }

    if (this.requiresDetails() && !(this.details && this.details.trim())) {
      return false;
    }

    return true;
  }

  buildRejectionReason() {
    const reasons = this.selectedReasons.filter((reason) => reason !== 'Other (explain below)');
    const details = (this.details || '').trim();
    const parts = [];

    if (reasons.length) {
      parts.push(reasons.join('; '));
    }

    if (details) {
      parts.push(details);
    }

    return parts.join('. ').trim();
  }

  confirm() {
    if (!this.canSubmit()) {
      this.errorMessage = this.selectedReasons.length
        ? 'Add specific details so the employee knows what to fix.'
        : 'Select at least one rejection reason.';
      return;
    }

    const reason = this.buildRejectionReason();
    if (!reason) {
      this.errorMessage = 'Enter a rejection reason.';
      return;
    }

    this.$uibModalInstance.close(reason);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default RejectExpenseModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-review-details/modals/reject-expense/reject-expense.controller.js